import React from "react";

function Takeyour() {
  return (
    <div className="take-bg">
      <div className="container mt-5 mb-5">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-11 col-md-12 col-sm-12 mt-5 mb-5">
            <h2 className="text-center Text-heading" data-aos="fade-up">
              Diverse Dubai App Engagement Models
            </h2>
            <p className="text-center text-detail mt-3" data-aos="fade-up">
              Make use of Virtual Tech experienced mobile app development
              services to create something spectacular.
            </p>
            <div className="text-center mt-3" data-aos="fade-up">
              <button className="btn btn-experts p-3">
                Get Free Consultation
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Takeyour;
